import script from "./TagArticlesView.vue?vue&type=script&setup=true&lang=js"
export * from "./TagArticlesView.vue?vue&type=script&setup=true&lang=js"

import "./TagArticlesView.vue?vue&type=style&index=0&id=4621a7ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4621a7ea"]])

export default __exports__